var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgShieldWithVBlue = function SvgShieldWithVBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1665 12.4L11.1665 14.4L15.6665 9.90002M20.1665 12.9C20.1665 17.8085 14.8125 21.3784 12.8645 22.5149C12.6431 22.6441 12.5324 22.7086 12.3762 22.7421C12.2549 22.7681 12.0781 22.7681 11.9568 22.7421C11.8006 22.7086 11.6899 22.6441 11.4685 22.5149C9.52047 21.3784 4.1665 17.8085 4.1665 12.9V8.11762C4.1665 7.31811 4.1665 6.91835 4.29726 6.57472C4.41278 6.27116 4.60049 6.00029 4.84416 5.78555C5.12 5.54246 5.4943 5.40209 6.24291 5.12137L11.6047 3.11069C11.8126 3.03273 11.9165 2.99375 12.0235 2.9783C12.1183 2.96459 12.2147 2.96459 12.3095 2.9783C12.4165 2.99375 12.5204 3.03273 12.7283 3.11069L18.0901 5.12137C18.8387 5.40209 19.213 5.54246 19.4888 5.78555C19.7325 6.00029 19.9202 6.27116 20.0357 6.57472C20.1665 6.91835 20.1665 7.31811 20.1665 8.11762V12.9Z",
    stroke: "#44739E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShieldWithVBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shield_with_v_blue.011fec7c.svg";
export { ForwardRef as ReactComponent };